import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ExcelService } from 'src/app/service/excel.service';
import { UtilityService } from 'src/app/service/utility.service';
import { ReasonListModalComponent } from '../../survey/Reason-list/reason-list-modal/reason-list-modal.component';
import { ReportService } from '../service/report.service';
import { SurveyService } from '../../survey/service/survey.service';
import { Router } from '@angular/router';
import { ClientListInfoService } from 'src/app/_metronic/layout/core/client-list-info.service';


@Component({
  selector: 'app-detail-report',
  templateUrl: './detail-report.component.html',
  styleUrls: ['./detail-report.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers:[DatePipe]
})
export class DetailReportComponent implements OnInit,OnDestroy {
  dateRangeForm: FormGroup;
  DAY = 86400000;
  public reasonList:any = [];
  public dateResetDone:boolean = true
  @ViewChild('startPicker') pickerStart: any;
  @ViewChild('endPicker') pickerEnd: any;

  public searchText:string='';
  dateRangeConfig: FlatpickrOptions = {
    mode: 'range',
    enableTime: false,
    dateFormat: 'd-m-Y',
    dateStrFormat:'d-m-Y',
    defaultDate:this.SetDateRange()
  };

  startOptions: FlatpickrOptions = {
    mode: 'single',
    dateFormat: 'd-m-Y',
    dateStrFormat:'d-m-Y',
    // defaultDate: new Date(Date.now() - (this.DAY*30)),
    defaultDate: this.getDefaultDate(),
    maxDate: new Date(),
  };


  endOptions: FlatpickrOptions = {
    mode: 'single',
    dateFormat: 'd-m-Y',
    dateStrFormat:'d-m-Y',
    defaultDate: new Date(),
    minDate: new Date(Date.now() - (this.DAY*30)),
    maxDate: new Date(),
  };


  public reports:any=[];
  public reportQuery:any ={}
  public reportResult:any ={}
  public isApiCallDone:boolean=false
  public hasFilter:boolean=false;
  dropdownSurveyList: any[] = [];
  // dropdownStatusList: any[] = [{id:0,name:'Drop'},{id:1,name:'Terminate'},{id:2,name:'Complete'},{id:3,name:'Over Quota'},{id:4,name:'Error'}];
  dropdownStatusList: any[] = [];
  dropdownClientList: any[] = [];
  selectedItems: any[] = [];
  selectedStatusItems: any[] = [];
  selectedPaymentStatusItems: any[] = [];
  selectedClients: any[] = [];
  dropdownSettings:IDropdownSettings = {};  
  dropdownStatusSettings:IDropdownSettings = {};  
  dropdownClientSettings:IDropdownSettings = {};
  public reportHeadersContainer:any=[];
  public switchUserAccess:boolean = false;
  public defaultSelectedUser:boolean = false;
  public clientSelectedUser:boolean = false;
  public accessRoles:any = {};
  public searchBy:string = "";
  public SearchByContainer:any = [];
  public ShowSearchBar:boolean = false;
  public selectedClientUUID :string = '';
  public responseStatusList: any[] = [];
  public paymentStatusList: any[] = [];
  public superUserPaymentStatusItems:any = [];
  public superUserResponseStatusItems:any = [];







  // scroll pagination
  throttle = 150;
  scrollDistance = 1;
  pageData = {pageNo: 1, page_size: 50};

  constructor(private fb: FormBuilder,
    public datepipe: DatePipe,
    private cd: ChangeDetectorRef,
    public reportService:ReportService,
    public excelService:ExcelService,
    private readonly renderer: Renderer2,
    public utility:UtilityService,
    public surveyService:SurveyService,
    public route:Router,
    public matDialoge:NgbModal,
    public clientService:ClientListInfoService,
    ) { 
      this.isApiCallDone = false;
        this.dateRangeForm = fb.group({
          dateRange: new Date(),
          // start:new Date(Date.now() - (this.DAY*30)),
          start:this.getDefaultDate(),
          end:new Date()
        });
        // this.dateRangeForm = fb.group({
        //   dateRange: new Date(),
        //   start:'',
        //   end:''
        // });
        this.reports = [];
        // Start Date Changes
        this.dateRangeForm.controls.start.valueChanges.subscribe(changes => {
          if (!changes[0]) return;
          const selectedDate = changes[0].getTime();
          this.pickerEnd.flatpickr.set({
            minDate: new Date(selectedDate),
          });
        });

        // End Date Changes
        this.dateRangeForm.controls.end.valueChanges.subscribe(changes => {
          console.log('end: ', changes);
          if (!changes[0]) return;
          const selectedDate = changes[0].getTime();
          this.pickerStart.flatpickr.set({
            maxDate: new Date( selectedDate)
          });

        });
        this.applyFilter();
    }

  ngOnDestroy(): void {
    this.utility.resetSortColumn();
  }

  ngOnInit(): void {
    this.pageData['pageNo'] = 1;
    this.selectedItems = [];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'survey_uuid',
      textField: 'survey_name',
      allowSearchFilter: true,
      enableCheckAll:true,
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
    };
    this.dropdownStatusSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'value',
      allowSearchFilter: true,
      enableCheckAll:true,
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
    };
    this.dropdownClientSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      allowSearchFilter: true,
      enableCheckAll:true,
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
    };
    this.getSurveyList();
    this.checkSwitchUserAccess();
    this.specifiedUser();
    this.setSearchByContainer();

  }


  getDefaultDate(){
    let date = new Date();
    date.setDate(1);
    date.setHours(0,0,0,0);
    return date
  }


  checkSwitchUserAccess(){
    this.accessRoles = JSON.parse(localStorage.getItem('access') || '');
    this.accessRoles = this.accessRoles.access_rules;
    if(this.accessRoles && this.accessRoles.header && this.accessRoles.header.switch_user){
      this.switchUserAccess = true;
      this.getAllClients()
    }
  }


  setSearchByContainer(){
    this.SearchByContainer = [];
    if(this.accessRoles.reports && this.accessRoles.reports.overall_report && this.accessRoles.reports.overall_report.search){
      let obj = this.accessRoles.reports.overall_report.search;
      let arr:any = [];
      Object.keys(obj).forEach((va:any) =>{
        if(obj[va]){
          arr.push(va);
        }
      })
      this.SearchByContainer = arr;
    }
  }


  specifiedUser(){
    if(localStorage.getItem('clientDetails')){
      let user:any = localStorage.getItem('clientDetails');
      user = JSON.parse(user);
      if(user.uuid){
        this.clientSelectedUser = true;
        this.defaultSelectedUser = false;
      }
      else
      {
        this.clientSelectedUser = false;
        this.defaultSelectedUser = true;
      }
    }
  }


  placeholderShow(){
    // return `Search by ${this.SearchByContainer.join(',')}`;
    return `Search`;
  }



  getAllClients(){
    this.clientService.getAllClients().subscribe({
      next: (res: any) =>{
        if (res['status'] == 1) {
          let arr = res['result'];
          this.clientService.clientList = arr;
          this.dropdownClientList = arr;
          this.cd.detectChanges();
        }
      },error :(e) =>{
        console.log(e)
      }
    })
  }


  redirectPageSurveyDetails(survey:any){
    this.surveyService.redirectFromInventory = false;
    this.surveyService.redirectFromCompletion = true;
    this.surveyService.redirectFromCompletionSurveyDetails = survey;
    localStorage.removeItem('selected_container');
    localStorage.setItem('redirectFromCompletionSurveyDetails',JSON.stringify(survey));
    // this.route.navigate(['/survey/details/',survey.survey_id]);
  }


  CreateRedirectLink(survey_id:any){
    return `${location.origin}/survey/details/${survey_id}`;
  }

  onScrollPagination() {
    this.pageData['pageNo']++;
    if (this.reportResult && this.reportResult.total_page >= this.pageData['pageNo']) {
      this.reportQuery.filter.page_no = this.pageData['pageNo'];
      this.getReports(this.reportQuery);
    }
  }

  SetDateRange(){
    let date = new Date();
    if(date.getMonth() > 1)
    {
      date.setMonth(date.getMonth()-1);
    }
    else
    {
      date.setFullYear(date.getFullYear() -1);
      date.setMonth(11);
    }
    let currDate = new Date();
    let priorDate = new Date(new Date().setDate(new Date().getDate() - 30));
    let str = "";
    str += this.datepipe.transform(priorDate, 'dd-MM-yyyy') || '';
    str += ' to ';
    str += this.datepipe.transform(currDate, 'dd-MM-yyyy') || '';
    return str;
  }

  onStartDateChange(){
    console.log("date chenged")
  }

  getSurvayIdFilter(){
    let survey_ids_filter = ''
    this.selectedItems.forEach((item:any, index:number) =>{
      survey_ids_filter += item.survey_uuid;
      if (index < this.selectedItems.length -1) {
        survey_ids_filter += ','
      }
    })
    return survey_ids_filter;
  }
  getSurvayStatusFilter(){
    let survey_status_filter = ''
    this.selectedStatusItems.forEach((item:any, index:number) =>{
      survey_status_filter += item.id;
      if (index < this.selectedStatusItems.length -1) {
        survey_status_filter += ','
      }
    })
    return survey_status_filter;
  }
  getSurvayPaymentStatusFilter(){
    let survey_payment_status_filter = ''
    this.selectedPaymentStatusItems.forEach((item:any, index:number) =>{
      survey_payment_status_filter += item.id;
      if (index < this.selectedPaymentStatusItems.length -1) {
        survey_payment_status_filter += ','
      }
    })
    return survey_payment_status_filter;
  }

  download(){
    this.getReasonList();
    // let filename = "report_"+this.datepipe.transform(this.reportQuery.filter.start_date, 'dd-MM-yyyy')+"_"+this.datepipe.transform(this.reportQuery.filter.end_date, 'dd-MM-yyyy')
    let filename = "report_"
    if (this.datepipe.transform(this.reportQuery.filter.start_date, 'dd-MM-yyyy') && this.datepipe.transform(this.reportQuery.filter.end_date, 'dd-MM-yyyy')) {
      filename += this.datepipe.transform(this.reportQuery.filter.start_date, 'dd-MM-yyyy')+"_"+this.datepipe.transform(this.reportQuery.filter.end_date, 'dd-MM-yyyy')
    }else if(this.datepipe.transform(this.reportQuery.filter.start_date, 'dd-MM-yyyy')){
      filename += "from_"+this.datepipe.transform(this.reportQuery.filter.start_date, 'dd-MM-yyyy')
    }else if(this.datepipe.transform(this.reportQuery.filter.end_date, 'dd-MM-yyyy')){
      filename += "till_"+this.datepipe.transform(this.reportQuery.filter.end_date, 'dd-MM-yyyy');
    }else{
      filename += "all";
    }
    let query :any = {
      "start_date":this.reportQuery.filter.start_date, 
      "end_date":this.reportQuery.filter.end_date, 
      "download":true
    }
   
    if (this.reportQuery.filter.survey_ids_filter && this.reportQuery.filter.survey_ids_filter != '') {
      query['survey_ids_filter'] = this.reportQuery.filter.survey_ids_filter
    }
    if (this.reportQuery.filter.survey_status_filter && this.reportQuery.filter.survey_status_filter != '') {
      query['survey_status_filter'] = this.reportQuery.filter.survey_status_filter
    }
    this.reportService.onDownloadOverallReport(query)
    .subscribe({
      next :(res:any) =>{
        if (res['status'] == 1) {
          let report = res.result
          // let reportObj = {'report':report}
          let reportObj = {'report':report, 'reasons':this.reasonList}
          // console.log("reportObj ",reportObj)
          this.excelService.exportMultipalJsonAsExcelFile(reportObj,filename)
        }
      },
      error: (e) =>{
        console.log(e);
      }
    })
  }

  getReasonList(){
    console.log("in reason list")
    this.reportService.getReasonList()
    .subscribe({
      next: (res: any) => {
        if (res['status'] == 1) {
          this.reasonList = res['reasons'];
          // console.log("this.reasonList ",this.reasonList )
          // this.reasonList = this.reasonList.map((va:any,index:any) => ({'Sl No.':index+1,'Reasons':va.label,'Brief':va.brief,'cases':va.cases.join(', ')}));
        }
      },error :(e) =>{
        console.log(e)
      }
    })
  }

  applyFilter(){
    this.pageData['pageNo'] = 1;

    this.reportQuery = {
    "filter": {
        "page_size":this.pageData['page_size'],
        "page_no":this.pageData['pageNo']
      }
    }

    if (this.selectedItems && this.selectedItems.length) {
      this.reportQuery['filter']['survey_ids_filter'] = this.getSurvayIdFilter()
    }
    if (this.selectedStatusItems && this.selectedStatusItems.length) {
      this.reportQuery['filter']['survey_status_filter'] = this.getSurvayStatusFilter()
    }
    if (this.selectedPaymentStatusItems && this.selectedPaymentStatusItems.length) {
      this.reportQuery['filter']['survey_payment_status_filter'] = this.getSurvayPaymentStatusFilter()
    }

    if (this.searchBy && this.searchBy != '') {
      this.reportQuery['filter']['searchBy'] = this.searchBy;
    }
    
    if (this.searchText && this.searchText != '' && this.searchText.length > 2) {
      this.reportQuery['filter']['search'] = this.searchText;
    }


    if (this.selectedClientUUID && this.selectedClientUUID != '') {
      // console.log("selected =>",this.selectedClientUUID);
      this.reportQuery['filter']['clientUUIDs'] = this.selectedClientUUID
    }



    if (this.superUserPaymentStatusItems && this.superUserPaymentStatusItems.length) {
      // console.log("this.selectedPaymentStatusItems",this.superUserPaymentStatusItems);
      this.reportQuery['filter']['payment_status_filter'] = this.getIdFilterStr(this.superUserPaymentStatusItems,'id')
    }


    if (this.superUserResponseStatusItems && this.superUserResponseStatusItems.length) {
      // console.log("this.selectedResponseStatusItems",this.superUserResponseStatusItems);
      this.reportQuery['filter']['response_status_filter'] = this.getIdFilterStr(this.superUserResponseStatusItems,'id')
    }


  

    // if (this.dateRangeForm.value.dateRange && Array.isArray(this.dateRangeForm.value.dateRange)) {
    //   this.reportQuery.filter.start_date = this.datepipe.transform(this.dateRangeForm.value.dateRange[0], 'yyyy-MM-dd hh:mm:ss') || '';
    //   this.reportQuery.filter.end_date = this.datepipe.transform(this.dateRangeForm.value.dateRange[1], 'yyyy-MM-dd hh:mm:ss') || '';
    // }else if(this.dateRangeForm.value.dateRange && !Array.isArray(this.dateRangeForm.value.dateRange)){
    //   let priorDate = new Date(new Date().setDate(new Date().getDate() - 30));
    //   this.reportQuery.filter.start_date = this.datepipe.transform(priorDate, 'yyyy-MM-dd hh:mm:ss') || '';
    //   this.reportQuery.filter.end_date = this.datepipe.transform(this.dateRangeForm.value.dateRange, 'yyyy-MM-dd hh:mm:ss') || '';
    // }

    if (this.dateRangeForm.value.start != '') {
      this.reportQuery.filter['start_date'] = Array.isArray(this.dateRangeForm.value.start) ? this.datepipe.transform(this.dateRangeForm.value.start[0], 'yyyy-MM-dd 00:00:00') : this.datepipe.transform(this.dateRangeForm.value.start, 'yyyy-MM-dd 00:00:00');
    }
    if (this.dateRangeForm.value.end != '') {
      this.reportQuery.filter['end_date'] =  Array.isArray(this.dateRangeForm.value.end) ?  this.datepipe.transform(this.dateRangeForm.value.end[0], 'yyyy-MM-dd 23:59:59') : this.datepipe.transform(this.dateRangeForm.value.end, 'yyyy-MM-dd 23:59:59');
    }
    this.dateResetDone = true;
    this.checkFilter();
    this.getReports(this.reportQuery);
  }

  checkFilter(){
    // console.log("this.reportQuery",this.reportQuery)
    if (Object.keys(this.reportQuery['filter']).includes('search')) {
      this.hasFilter = Object.keys(this.reportQuery['filter']).length > 3;
    }else{
      this.hasFilter = Object.keys(this.reportQuery['filter']).length > 2;
    }
  }
  resetFilter(){
    this.selectedItems = []
    this.selectedStatusItems = []
    this.selectedPaymentStatusItems = []
    this.selectedClients = []
    this.selectedClientUUID = '';
    this.superUserPaymentStatusItems = [];
    this.superUserResponseStatusItems = [];


    // this.dateRangeForm.patchValue({
    //   dateRange:new Date(Date.now() - (this.DAY*30)),
    //   start:new Date(Date.now() - (this.DAY*30)),
    //   end:new Date(),
    // })
    this.dateRangeForm.patchValue({
      dateRange:'',
      start:'',
      end:'',
    })
    this.dateResetDone = false;
    this.cd.detectChanges()
    this.applyFilter()
  }



  getIdFilterStr(slectedList:any[],key:string){
    let str = ''
    slectedList.forEach((item:any, index:number) =>{
      
      str += item[key];
      if (index < slectedList.length -1) {
        str += ','
      }
    })
    return str;
  }

  getReports(query:any){
    this.reportService.getOverallReport(query)
    .subscribe({
      next :(res:any) =>{
        if (res['status'] == 1) {
          this.reportResult = res;
          if (res.page_no == 1) {
            this.reports = res.result;
          }else{
            this.reports = [...this.reports, ...res.result];
          }
          console.log("getReports overall ===> ",res);
          if(res.respons_status_arr){
            this.responseStatusList = res.respons_status_arr
          }
          if(res.payment_status_arr){
            this.paymentStatusList = res.payment_status_arr
          }
          // this.dropdownStatusList = res.survey_status_map
          // this.dropdownClientList = res.survey_status_map
          this.cd.detectChanges();
        }
      },
      error: (e) =>{
        console.log(e);
      },
      complete:() => {
        this.isApiCallDone = true;
        this.reportHeadersContainer = [];
        this.setHeadersForReports();
        this.cd.detectChanges();
      }
    })
  }


  setHeadersForReports(){
    this.reportHeadersContainer = Object.keys(this.reports[0]);
    this.reportHeadersContainer.unshift('SL');
    let arr = this.reportHeadersContainer;
    let header_arr = ['Sl NO.','PID','RID','Survey ID','Client','CPI','LOI','Response Status','Payment Status','CAG','Start Time','End Time'];
    // for(let i=0;i<arr.length;i++){
    //   switch (arr[i]){
    //     case 'SL':
    //       header_arr[0] = 'Sl No.';
    //       break;
    //     case 'survey_name':
    //       header_arr[3] = 'Survey ID';
    //       break;
    //     case 'pid':
    //       header_arr[1] = 'PID';
    //       break;
    //     case 'start_time':
    //       header_arr[10] = 'Start Time';
    //       break;
    //     case 'end_time':
    //       header_arr[11] = 'End Time';
    //       break; 
    //     case 'cpi':
    //       header_arr[5] = 'CPI';
    //       break; 
    //     case 'loi':
    //       header_arr[6] = 'LOI';
    //       break;           
    //     case 'response_status':
    //       header_arr[7] = 'Response Status';
    //       break; 
    //     case 'payment_status':
    //       header_arr[8] = 'Payment Status';
    //       break; 
    //     case 'rid':
    //       header_arr[2] = 'RID';
    //       break;
    //     case 'cags':
    //       header_arr[9] = 'CAG';
    //       break;
    //     case 'client_name':
    //       header_arr[4] = 'Client';
    //       break;
    //     case 'rejection_reason':
    //       header_arr[8] = '';
    //       break;            
    //     default :
    //       header_arr[12] = ""  
    //   }
    // }
    // this.reportHeadersContainer = header_arr.filter((va:any) => (va ? true : false));
    this.reportHeadersContainer = header_arr;

  }



  SetGridColumns(){
    let val = 'repeat(' + this.reportHeadersContainer.length + ',' + 'minmax(60px,120px)' + ')';
    // console.log(val);
    return val;
  }



  CagsDeatailsModalOpen(cags:any){
    this.surveyService.showCagsDeatilsModal = true;
    this.surveyService.showReasonListModal = false;
    this.surveyService.surveyCagsDeatils = cags
    this.matDialoge.open(ReasonListModalComponent, { size:'lg',scrollable: true,centered:true,windowClass:'PopupComponentComponent'});

  }



  getSurveyList(){
    let status = "false"
    this.reportService.getSurveyList(status)
    .subscribe({
      next :(res:any) =>{
        if (res['status'] == 1) {
          this.dropdownSurveyList = res.result
          // console.log(this.dropdownSurveyList,'SurveyList');
          this.cd.detectChanges();
        }
      },
      error: (e) =>{
        console.log(e);
      },
      complete:() => {
        this.isApiCallDone = true
        this.cd.detectChanges();
      }
    })
  }
  onItemSelect(item: any) {
    // console.log(item);
  }
  onSelectAll(items: any) {
    // console.log(items);

  }



  getSelectedItems(len:number){
    if (this.selectedItems && this.selectedItems.length > 0) {
      let items = [];
      items = this.selectedItems.map(item => item.survey_name);
      let str = items.join(', ')
      if (str.length > len) {
        let isCommaAtBorder = str.charAt(len) == ',';
        // console.log(`The character at index ${len} is ${str.charAt(len)}`)
        str = this.utility.getSubStr(str,len,{isDots:true});
        let count = str.split(",").length -1;
        count = isCommaAtBorder ? count+1 : count;
        if ((items.length - count) > 0) {
          return str + " +"+ (items.length - count)
        }else{
          return str 
        }
      }else{
        return str
      }
    }else{
      return ""
    }
    
  }






 
  getSelectedItems1(list:any[],key:string,len:number){
    if (list && list.length > 0) {
      let items = [];
      items = list.map(item => item[key]);
      let str = items.join(', ')
      if (str.length > len) {
        let isCommaAtBorder = str.charAt(len) == ',';
        str = this.utility.getSubStr(str,len,{isDots:true});
        let count = str.split(",").length -1;
        count = isCommaAtBorder ? count+1 : count;
        if ((items.length - count) > 0) {
          return str + " +"+ (items.length - count)
        }else{
          return str 
        }
      }else{
        return str
      }
    }else{
      return ""
    }
  }




  ReasonListModalPopup(){
    this.matDialoge.open(ReasonListModalComponent, { size:'xl',scrollable: true,centered:true});
  }
  onSearchChange(){
    // console.log(this.searchText);
    if (this.searchText.length > 2) {
      this.applyFilter();
    }else if(this.searchText == ''){
      this.applyFilter();
    }else{
      delete this.reportQuery['filter'].search
      this.checkFilter();
    }
  }


  onSearchByChange(){
    if (this.searchText.length > 0) {
      this.applyFilter();
    }else if(this.searchText == ''){
      this.applyFilter();
    }else{
      delete this.reportQuery['filter'].search
      this.checkFilter();
    }
  }


 


  formatSurveyrid(text:any){
    if(text.length < 10)
    {
      return text;
    }
    else
    {
      return text.substr(0, 10) + '...';
    }
  }


  searchByChange(){
    if(this.searchBy && this.searchBy != '')
    {
      this.ShowSearchBar = true;
      this.searchText = '';
    }
    else
    {
      this.ShowSearchBar = false;
    }
    this.onSearchByChange();

  }


  copyClipBoard(type:any,id:any){
    this.utility.copyOnClick(id,type);
    // this.notifier.notify('success',`${type} copy successfully`);
  }



  paymentStatusModalOpen(rid:any){
    this.surveyService.responseReportType = 'overall';
    this.surveyService.responseDetails_rid = rid;
    this.surveyService.showCagsDeatilsModal = false;
    this.surveyService.showReasonListModal = false;
    this.surveyService.responseStatusModalOpen = false;
    this.surveyService.paymentStatusModalOpen = true;
    this.matDialoge.open(ReasonListModalComponent, { size:'lg',scrollable: true,centered:true,windowClass:'PopupComponentComponent'});
  }

  responseStatusModalOpen(rid:any){
    this.surveyService.responseReportType = 'overall';
    this.surveyService.responseDetails_rid = rid;
    this.surveyService.showCagsDeatilsModal = false;
    this.surveyService.showReasonListModal = false;
    this.surveyService.paymentStatusModalOpen = false;
    this.surveyService.responseStatusModalOpen = true;
    this.matDialoge.open(ReasonListModalComponent, { size:'lg',scrollable: true,centered:true,windowClass:'PopupComponentComponent'});
  }
}
